import { Container, Grid, Typography, Button, Paper, makeStyles, Theme, createStyles } from '@material-ui/core';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { QualityScore } from '../Quality';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { ViewIcon } from '../../../../icons/ViewIcon';
import { WarningIcon } from '../../../../icons/WarningIcon';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      float: 'left',
      [theme.breakpoints.down('md')]: {
        float: 'initial',
      },
    },
    heading: {
      position: 'relative',
    },
    paper: {
      padding: '1.2em',
      maxWidth: '400px',
      borderRadius: '8px',
      '& li': {
        '&:not(:last-child)': {
          marginBottom: '1.5em',
        },
      },
    },
    paperContainer: {
      float: 'right',
      marginRight: '1em',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        float: 'initial',
        justifyContent: 'center',
        margin: '0 0 2.5em 0',
      },
    },
    viewButton: {
      marginTop: '2em',
      '& svg': {
        position: 'relative',
        left: '-5px',
      },
    },
    confirmationButtons: {
      clear: 'left',
      [theme.breakpoints.down('md')]: {
        clear: 'initial',
        marginBottom: '2em',
      },
    },
  })
);

interface PoorQualityProps {
  quality: QualityScore | undefined;
  openModal: () => void;
}

export function PoorQuality({ quality, openModal }: PoorQualityProps) {
  const { t } = useTranslation();
  const { nextPane } = useAppStateContext();
  const classes = useStyles();

  return (
    <Container>
      <div>
        <Grid item lg={5} className={classes.header}>
          <Typography variant="h1" gutterBottom className={classes.heading}>
            {quality === QualityScore.Suboptimal ? <WarningIcon /> : <ErrorIcon />}
            {t('Quality')}
            {quality === QualityScore.Suboptimal ? t('Quality.IsOk') : t('Quality.Issue')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            {t('Quality.Desc_01')}
            <strong>{quality === QualityScore.Suboptimal ? t('Suboptimal') : t('Degraded')}</strong>
            {t('Quality.Desc_02')}
            {quality === QualityScore.Suboptimal ? t('Quality.CouldBeBetter') : t('Quality.WillBePoor')}.
          </Typography>
        </Grid>

        <Grid item lg={5} className={classes.paperContainer}>
          <Paper className={classes.paper}>
            <Typography variant="body1">
              <strong>{t('Quality.Tips.Title')}</strong>
            </Typography>

            <ul>
              <li>
                <Typography variant="body1">{t('Quality.Tips.1')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('Quality.Tips.2')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('Quality.Tips.3')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('Quality.Tips.3')}</Typography>
              </li>
            </ul>
          </Paper>

          <Button variant="outlined" onClick={openModal} className={classes.viewButton}>
            <ViewIcon />
            {t('Quality.Button.ViewInfo')}
          </Button>
        </Grid>

        <Grid item lg={5} className={classes.confirmationButtons}>
          <Typography variant="body1" gutterBottom>
            <strong>{t('Quality.Tips.Alert')}</strong>
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={nextPane}
            style={{ marginRight: '1.5em', color: 'white' }}
          >
            {t('Button.Yes')}
          </Button>
          <Button color="primary" onClick={nextPane} style={{ color: 'white' }}>
            {t('Button.SkipForNow')}
          </Button>
        </Grid>
      </div>
    </Container>
  );
}
